import { render } from "./VDropdownDivider.vue?vue&type=template&id=6b637d59&ts=true"
import script from "./VDropdownDivider.vue?vue&type=script&lang=ts"
export * from "./VDropdownDivider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__